import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Plus, HelpCircle } from "lucide-react";

import Seo from "../../Components/SEO/Seo";
import Container from "../../Components/Container/Container";
import { faqs } from "../../Data/faqData";

import "../../Style/home/faq.css";
import "../../Style/resources/faq.css";

export default function Faq() {
  const [openId, setOpenId] = useState(faqs?.[0]?.id ?? null);

  return (
    <div className="faq-page">
      <Seo
        title="Frequently Asked Questions | Conectify Tech"
        description="Find answers to common questions about Conectify Tech data solutions, lead generation, verification, and custom scoping."
      />

      {/* Top Resource Banner */}
      <section className="faq-banner">
        <Container>
          <div className="faq-banner__content">
            <span className="faq-banner__tag">
              <HelpCircle size={14} /> Knowledge & Guidance
            </span>
            <h1 className="faq-banner__title">Frequently Asked Questions</h1>
          </div>
        </Container>
      </section>

      {/* FAQ Accordion Section */}
      <section className="section section--plain faq">
        <Container size="narrow">
          <div className="section-title text-center" style={{ marginBottom: "36px" }}>
            <span className="section-eyebrow">FAQ</span>
            <h2 className="section-title__heading">
              Frequently asked <span className="text-gradient">questions.</span>
            </h2>
          </div>

          <div className="faq__list">
            {Array.isArray(faqs) &&
              faqs.map((item) => {
                const isOpen = openId === item.id;

                return (
                  <div
                    key={item.id}
                    className={`faq__item ${isOpen ? "faq__item--open" : ""}`}
                  >
                    <button
                      type="button"
                      className="faq__question"
                      onClick={() => setOpenId(isOpen ? null : item.id)}
                      aria-expanded={isOpen}
                    >
                      <span>{item.question}</span>
                      <motion.span
                        className="faq__icon"
                        animate={{ rotate: isOpen ? 45 : 0 }}
                        transition={{ duration: 0.25 }}
                      >
                        <Plus size={18} />
                      </motion.span>
                    </button>

                    <AnimatePresence initial={false}>
                      {isOpen && (
                        <motion.div
                          className="faq__answer-wrap"
                          initial={{ height: 0, opacity: 0 }}
                          animate={{ height: "auto", opacity: 1 }}
                          exit={{ height: 0, opacity: 0 }}
                          transition={{ duration: 0.3, ease: [0.16, 1, 0.3, 1] }}
                        >
                          <p className="faq__answer">{item.answer}</p>
                        </motion.div>
                      )}
                    </AnimatePresence>
                  </div>
                );
              })}
          </div>
        </Container>
      </section>
    </div>
  );
}